// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	window.onload = function() {
		onLoad();
	};

	/* Main Nav */
	const burgerMenuBtn = document.getElementById('js-menu-trigger');
	const burgerMenuClose = document.getElementById('js-close-menu');
	const burgerMenu = document.getElementById('burger-menu');
	const primaryNav = document.querySelectorAll('#primary-nav li');


	burgerMenuBtn.addEventListener('click', (e) =>{
		e.preventDefault();
		burgerMenu.classList.add('open');
		document.body.classList.add('no-scroll');
	});

	burgerMenuClose.addEventListener('click', () =>{
		burgerMenu.classList.remove('open');
		document.body.classList.remove('no-scroll');
	});
	
	primaryNav.forEach(primary => {
		if(primary.querySelector('.submenu')){
			primary.classList.add('li-sub');
			primary.querySelector('a').addEventListener("click", (e) => {
				e.preventDefault();
			});
		}
		if(primary.querySelector('.submenu .active')) {
			primary.querySelector("a").classList.add('parent-active')
		}

		primary.addEventListener('click', function(event) {
			let target = event.target;
			
			while (target && !target.classList.contains('li-sub')) {
				target = target.parentElement;
			}
			
			if (target) {
				if (!target.classList.contains('active')) {
					document.querySelectorAll('.li-sub.active').forEach(el => {
						el.classList.remove('active');
						el.querySelector('ul.submenu').classList.remove('open');
					});
					target.classList.add('active');
					target.querySelector('ul.submenu').classList.add('open');
					document.querySelector('.burger-inner').classList.add('submenu-open');
				} else {
					target.classList.remove('active');
					target.querySelector('ul.submenu').classList.remove('open');
					document.querySelector('.burger-inner').classList.remove('submenu-open');
				}
			}
		});
	});

	if( window.innerWidth < 641 ){
		let allSubAnchor = document.querySelectorAll('.privary-navigation__submenu a');
		allSubAnchor.forEach(anchor => {
			let text = anchor.innerHTML;
			anchor.innerHTML = text.replaceAll('<br>', '');
		});
	}
			
	/* vanilla JS fancybox */
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lbxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open');
				document.body.classList.add('no-scroll');
			});

		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}

		let allCloseTerms = document.getElementsByClassName('js-close-terms');
		let allTermsLight = document.querySelectorAll('.terms-lbx');

		for(let j = 0; j < allCloseTerms.length; j++ ){
			allCloseTerms[j].addEventListener('click', function(e){
				e.preventDefault();
				allTermsLight.forEach(el => el.classList.remove('open'));
			});
		};

		let allLbxWraps = document.querySelectorAll('.lightbox');

		for(const lbxWrap of allLbxWraps) {
			lbxWrap.addEventListener('click', (e) => {
				const innerWrap = lbxWrap.querySelector('.lightbox-wrap') ;
				if(!innerWrap.contains(e.target)) {
					allLbxWraps.forEach(el => el.classList.remove('open'));
					document.body.classList.remove('no-scroll');
				}
			})
		}
	};

	/* Anchor Animation */
	let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-lbx], a.js-lbxbtn, a.js-lightboxclose, a#js-close-form))");
	if(aHref){
		aHref.forEach(function(a_href) {
			a_href.addEventListener('click', function(e){
				e.preventDefault();
				let strAnchor = this.hash.slice(1);
				animateto(strAnchor);
			});
		});
	}


	let dateInputs = document.querySelectorAll('input[type="date"],input[type="time"]');
	if (dateInputs.length > 0) {
		dateInputs.forEach(function(input) {
			input.addEventListener('click', function() {
				this.classList.add('clicked');
			});
		});
	}

	let allCards = document.querySelectorAll('.cards .item');
	if(allCards.length > 0){
		allCards.forEach((el)=>{
			el.addEventListener('click', function(e){
				if(e.target != this.querySelector('.btn-2')){
					this.classList.toggle('active');
				}
			});
		});
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

const headerLogo = document.querySelector('.js-scroll-logo');
const header = document.getElementById('header');


function onLoad() {
    if (document.getElementsByClassName('no-hero').length < 1) {
        scrollW();
    } else {
        document.getElementById('header').classList.add('scroll');
		if(headerLogo)
        	changeSrc(headerLogo.getElementsByTagName('img')[0]);
    }

    window.addEventListener('scroll', function () {
        scrollW();
    });
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!header.classList.contains('scroll')){
			header.classList.add('scroll');
			if(headerLogo){
				changeSrc(headerLogo.getElementsByTagName('img')[0]);
			}
		};
	} else {
		if (document.getElementsByClassName('no-hero').length < 1) {
			if (header.classList.contains('scroll')) {
				header.classList.remove('scroll');
				if(headerLogo){
					changeSrc(headerLogo.getElementsByTagName('img')[0]);
				}
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function changeSrc(elem) {
	let target = elem.getAttribute('data-scroll');
	let currentSrc = elem.getAttribute('src');

	elem.setAttribute('src', target);
	elem.setAttribute('data-scroll', currentSrc);
}


function animateto(target){
    let gotoTarget = offset(document.getElementById(target)).top - 120;
    let from     = window.pageYOffset
    let to       = gotoTarget
    let duration = 500;
    let start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)
} 

function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#burger-menu');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('#primary-nav .privary-navigation__item a, #secondary-main .secondary-navigation__item a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#burger-menu');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }


	let allFormsToAddAriaLabel = document.querySelectorAll(`form.form-module, form.email-signup`);
	if( allFormsToAddAriaLabel ){
		allFormsToAddAriaLabel.forEach( form => {
			console.log(form.id);
			let submitAriaLabel = '';
			switch (form.id) {
				case 'form_id-3657StartPlanning':
					submitAriaLabel = 'submit weddings rfp form'
					break;

				case 'form_id-3654':
					submitAriaLabel = 'submit meetings and events rfp form'
					break;
				case 'form_id-3658ContactUsForm':
					submitAriaLabel = 'submit contact form'
					break;

				case 'email-signup':
					submitAriaLabel = 'subscribe to our email database'
					break;

				default:
					submitAriaLabel = 'Submit'
					break;
			}
			form.querySelector('button[type="submit"]').setAttribute( 'aria-label', submitAriaLabel)
		} );
	}
});